import _typeof from "/home/jenkins/workspace/AI\u5408\u89C4\u524D\u7AEF-\u6D4B\u8BD5/node_modules/@babel/runtime/helpers/esm/typeof.js";
import _classCallCheck from "/home/jenkins/workspace/AI\u5408\u89C4\u524D\u7AEF-\u6D4B\u8BD5/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/jenkins/workspace/AI\u5408\u89C4\u524D\u7AEF-\u6D4B\u8BD5/node_modules/@babel/runtime/helpers/esm/createClass.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.error.to-string.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.date.to-json.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.dot-all.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.sticky.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
/** 是否打印日志 */
var isPrintLog = false;
function printLog(params) {
  if (isPrintLog) {
    console.log(JSON.stringify(params));
  }
}

/**
 * 清除默认事件
 * @param event event
 */
function clearPreventDefault(event) {
  if (event.preventDefault) {
    event.preventDefault();
  }
}

/**
 * 阻止某div默认事件
 * @param dom
 */
function clearAllPreventDefault(dom) {
  Dom(dom).each(function (el) {
    // 手机端
    el.addEventListener('touchmove', clearPreventDefault, {
      passive: false
    });
    // pc端
    el.addEventListener('mousemove', clearPreventDefault, {
      passive: false
    });
  });
}
function reductionAllPreventDefault(dom) {
  Dom(dom).each(function (el) {
    el.removeEventListener('touchmove', clearPreventDefault);
    el.addEventListener('mousemove', clearPreventDefault);
  });
}

/**
 * 获取当前坐标
 * @param event 事件
 * @returns {{x: number, y: number}}
 */
function getCurrentCoordinate(event) {
  if (event.pageX !== null && event.pageX !== undefined) {
    return {
      x: Math.round(event.pageX),
      y: Math.round(event.pageY)
    };
  }
  var targetTouches;
  if (event.changedTouches) {
    // 抬起事件
    targetTouches = event.changedTouches;
  } else if (event.targetTouches) {
    // pc 按下事件
    targetTouches = event.targetTouches;
  } else if (event.originalEvent && event.originalEvent.targetTouches) {
    // 鼠标触摸事件
    targetTouches = event.originalEvent.targetTouches;
  }
  if (targetTouches[0].pageX !== null && targetTouches[0].pageX !== undefined) {
    return {
      x: Math.round(targetTouches[0].pageX),
      y: Math.round(targetTouches[0].pageY)
    };
  }
  return {
    x: Math.round(targetTouches[0].clientX),
    y: Math.round(targetTouches[0].clientY)
  };
}
function down(currentCaptcha, event) {
  // debugger
  var coordinate = getCurrentCoordinate(event);
  var startX = coordinate.x;
  var startY = coordinate.y;
  currentCaptcha.currentCaptchaData.startX = startX;
  currentCaptcha.currentCaptchaData.startY = startY;
  var trackList = currentCaptcha.currentCaptchaData.trackList;
  currentCaptcha.currentCaptchaData.startTime = new Date();
  var startTime = currentCaptcha.currentCaptchaData.startTime;
  trackList.push({
    x: coordinate.x,
    y: coordinate.y,
    type: "down",
    t: new Date().getTime() - startTime.getTime()
  });
  printLog(["start", startX, startY]);
  currentCaptcha.__m__ = move.bind(null, currentCaptcha);
  currentCaptcha.__u__ = up.bind(null, currentCaptcha);
  // pc
  window.addEventListener("mousemove", currentCaptcha.__m__);
  window.addEventListener("mouseup", currentCaptcha.__u__);
  // 手机端
  window.addEventListener("touchmove", currentCaptcha.__m__, false);
  window.addEventListener("touchend", currentCaptcha.__u__, false);
  if (currentCaptcha && currentCaptcha.doDown) {
    currentCaptcha.doDown(event, currentCaptcha);
  }
}
function move(currentCaptcha, event) {
  if (event.touches && event.touches.length > 0) {
    event = event.touches[0];
  }
  // debugger
  var coordinate = getCurrentCoordinate(event);
  var pageX = coordinate.x;
  var pageY = coordinate.y;
  var startX = currentCaptcha.currentCaptchaData.startX;
  var startY = currentCaptcha.currentCaptchaData.startY;
  var startTime = currentCaptcha.currentCaptchaData.startTime;
  var end = currentCaptcha.currentCaptchaData.end;
  var bgImageWidth = currentCaptcha.currentCaptchaData.bgImageWidth;
  var trackList = currentCaptcha.currentCaptchaData.trackList;
  var moveX = pageX - startX;
  var moveY = pageY - startY;
  var track = {
    x: coordinate.x,
    y: coordinate.y,
    type: "move",
    t: new Date().getTime() - startTime.getTime()
  };
  trackList.push(track);
  if (moveX < 0) {
    moveX = 0;
  } else if (moveX > end) {
    moveX = end;
  }
  currentCaptcha.currentCaptchaData.moveX = moveX;
  currentCaptcha.currentCaptchaData.moveY = moveY;
  if (currentCaptcha.doMove) {
    currentCaptcha.doMove(event, currentCaptcha);
  }
  printLog(["move", track]);
}
function destroyEvent(currentCaptcha) {
  if (currentCaptcha) {
    if (currentCaptcha.__m__) {
      window.removeEventListener("mousemove", currentCaptcha.__m__);
      window.removeEventListener("touchmove", currentCaptcha.__m__);
    }
    if (currentCaptcha.__u__) {
      window.removeEventListener("mouseup", currentCaptcha.__u__);
      window.removeEventListener("touchend", currentCaptcha.__u__);
    }
  }
}
function up(currentCaptcha, event) {
  destroyEvent(currentCaptcha);
  var coordinate = getCurrentCoordinate(event);
  currentCaptcha.currentCaptchaData.stopTime = new Date();
  var startTime = currentCaptcha.currentCaptchaData.startTime;
  var trackList = currentCaptcha.currentCaptchaData.trackList;
  var track = {
    x: coordinate.x,
    y: coordinate.y,
    type: "up",
    t: new Date().getTime() - startTime.getTime()
  };
  trackList.push(track);
  printLog(["up", track]);
  printLog(["tracks", trackList]);
  if (currentCaptcha.doUp) {
    currentCaptcha.doUp(event, currentCaptcha);
  }
  currentCaptcha.endCallback(currentCaptcha.currentCaptchaData, currentCaptcha);
}
function initConfig(bgImageWidth, bgImageHeight, templateImageWidth, templateImageHeight, end) {
  // bugfix 图片宽高可能会有小数情况，强转一下整数
  var currentCaptchaConfig = {
    startTime: new Date(),
    trackList: [],
    movePercent: 0,
    clickCount: 0,
    bgImageWidth: Math.round(bgImageWidth),
    bgImageHeight: Math.round(bgImageHeight),
    templateImageWidth: Math.round(templateImageWidth),
    templateImageHeight: Math.round(templateImageHeight),
    end: end
  };
  printLog(["init", currentCaptchaConfig]);
  return currentCaptchaConfig;
}
function _closeTips(el, callback) {
  var tipEl = Dom(el).find("#tianai-captcha-tips");
  tipEl.removeClass("tianai-captcha-tips-on");
  // tipEl.removeClass("tianai-captcha-tips-success")
  // tipEl.removeClass("tianai-captcha-tips-error")
  // 延时
  if (callback) {
    setTimeout(callback, .35);
  }
}
function _showTips(el, msg, type, callback) {
  var tipEl = Dom(el).find("#tianai-captcha-tips");
  tipEl.text(msg);
  if (type === 1) {
    // 成功
    tipEl.removeClass("tianai-captcha-tips-error");
    tipEl.addClass("tianai-captcha-tips-success");
  } else {
    // 失败
    tipEl.removeClass("tianai-captcha-tips-success");
    tipEl.addClass("tianai-captcha-tips-error");
  }
  tipEl.addClass("tianai-captcha-tips-on");
  // 延时
  setTimeout(callback, 1000);
}
var CommonCaptcha = /*#__PURE__*/function () {
  function CommonCaptcha() {
    _classCallCheck(this, CommonCaptcha);
  }
  return _createClass(CommonCaptcha, [{
    key: "showTips",
    value: function showTips(msg, type, callback) {
      _showTips(this.el, msg, type, callback);
    }
  }, {
    key: "closeTips",
    value: function closeTips(msg, callback) {
      _closeTips(this.el, msg, callback);
    }
  }]);
}();
function Dom(domStr, dom) {
  return new DomEl(domStr, dom);
}
var DomEl = /*#__PURE__*/function () {
  function DomEl(domStr, dom) {
    _classCallCheck(this, DomEl);
    if (dom && _typeof(dom) === 'object' && typeof dom.nodeType !== 'undefined') {
      this.dom = dom;
      this.domStr = domStr;
      return;
    }
    if (domStr instanceof DomEl) {
      this.dom = domStr.dom;
      this.domStr = domStr.domStr;
    } else if (typeof domStr === "string") {
      this.dom = document.querySelector(domStr);
      this.domStr = domStr;
    } else if ((typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && typeof document.nodeType !== 'undefined') {
      this.dom = domStr;
      this.domStr = domStr.nodeName;
    } else {
      throw new Error("不支持的类型");
    }
  }
  return _createClass(DomEl, [{
    key: "each",
    value: function each(callback) {
      this.getTarget().querySelectorAll("*").forEach(callback);
    }
  }, {
    key: "removeClass",
    value: function removeClass(className) {
      var element = this.getTarget();
      if (element.classList) {
        // 使用 classList API 移除类
        element.classList.remove(className);
      } else {
        // 兼容旧版本浏览器
        var currentClass = element.className;
        var regex = new RegExp('(?:^|\\s)' + className + '(?!\\S)', 'g');
        element.className = currentClass.replace(regex, '');
      }
      return this;
    }
  }, {
    key: "addClass",
    value: function addClass(className) {
      var element = this.getTarget();
      if (element.classList) {
        // 使用 classList API 添加类
        element.classList.add(className);
      } else {
        // 兼容旧版本浏览器
        var currentClass = element.className;
        if (currentClass.indexOf(className) === -1) {
          element.className = currentClass + ' ' + className;
        }
      }
      return this;
    }
  }, {
    key: "find",
    value: function find(str) {
      var el = this.getTarget().querySelector(str);
      if (el) {
        return new DomEl(str, el);
      }
      return null;
    }
  }, {
    key: "children",
    value: function children(selector) {
      var childNodes = this.getTarget().childNodes;
      for (var i = 0; i < childNodes.length; i++) {
        if (childNodes[i].nodeType === 1 && childNodes[i].matches(selector)) {
          return new DomEl(selector, childNodes[i]);
        }
      }
      return null;
    }
  }, {
    key: "remove",
    value: function remove() {
      this.getTarget().remove();
      return null;
    }
  }, {
    key: "css",
    value: function css(property, value) {
      if (typeof property === 'string' && typeof value === 'string') {
        // 设置单个属性
        this.getTarget().style[property] = value;
      } else if (_typeof(property) === 'object') {
        // 设置多个属性
        for (var prop in property) {
          if (property.hasOwnProperty(prop)) {
            this.getTarget().style[prop] = property[prop];
          }
        }
      } else if (typeof property === 'string' && typeof value === 'undefined') {
        // 获取单个属性
        return window.getComputedStyle(element)[property];
      }
    }
  }, {
    key: "attr",
    value: function attr(attributeName, value) {
      if (value === undefined) {
        // 如果未提供值，则返回属性的当前值
        return this.getTarget().getAttribute(attributeName);
      } else {
        // 如果提供了值，则设置属性的值
        this.getTarget().setAttribute(attributeName, value);
      }
      return this;
    }
  }, {
    key: "text",
    value: function text(str) {
      this.getTarget().innerText = str;
      return this;
    }
  }, {
    key: "html",
    value: function html(str) {
      this.getTarget().innerHtml = str;
      return this;
    }
  }, {
    key: "is",
    value: function is(dom) {
      if (dom && _typeof(dom) === 'object' && typeof dom.nodeType !== 'undefined') {
        return this.dom === dom;
      }
      if (dom instanceof DomEl) {
        return this.dom === dom.dom;
      }
    }
  }, {
    key: "append",
    value: function append(content) {
      if (typeof content === 'string') {
        this.getTarget().insertAdjacentHTML("beforeend", content);
      } else if (content instanceof HTMLElement) {
        this.getTarget().appendChild(content);
      } else {
        throw new Error('Invalid content type');
      }
      return this;
    }
  }, {
    key: "click",
    value: function click(fun) {
      this.on("click", fun);
      return this;
    }
  }, {
    key: "mousedown",
    value: function mousedown(fun) {
      this.on("mousedown", fun);
      return this;
    }
  }, {
    key: "touchstart",
    value: function touchstart(fun) {
      this.on("touchstart", fun);
      return this;
    }
  }, {
    key: "on",
    value: function on(eventType, fun) {
      this.getTarget().addEventListener(eventType, fun, {
        passive: true
      });
      return this;
    }
  }, {
    key: "width",
    value: function width() {
      return this.getTarget().offsetWidth;
    }
  }, {
    key: "height",
    value: function height() {
      return this.getTarget().offsetHeight;
    }
  }, {
    key: "getTarget",
    value: function getTarget() {
      if (this.dom) {
        return this.dom;
      }
      throw new Error("dom不存在: [" + this.domStr + "]");
    }
  }]);
}();
function http(options) {
  return new Promise(function (resolve, reject) {
    var xhr = new XMLHttpRequest();

    // 添加CORS支持
    if (options.withCredentials) {
      xhr.withCredentials = true;
    }
    xhr.open(options.method || 'GET', options.url);

    // 设置请求头
    if (options.headers) {
      for (var header in options.headers) {
        if (options.headers.hasOwnProperty(header)) {
          xhr.setRequestHeader(header, options.headers[header]);
        }
      }
    }
    xhr.onreadystatechange = function () {
      if (xhr.readyState === XMLHttpRequest.DONE) {
        if (xhr.status >= 200 && xhr.status < 400) {
          var contentType = xhr.getResponseHeader('Content-Type');
          if (contentType && contentType.indexOf('application/json') !== -1) {
            try {
              resolve(JSON.parse(xhr.responseText));
            } catch (e) {
              resolve(xhr.responseText);
            }
          } else {
            resolve(xhr.responseText);
          }
        } else if (xhr.status === 0) {
          // 状态码为0通常表示CORS错误或网络错误
          reject(new Error('CORS错误或网络连接失败，请检查服务器CORS配置或网络连接'));
        } else {
          reject(new Error('Request failed with status: ' + xhr.status + ' - ' + xhr.statusText));
        }
      }
    };
    xhr.onerror = function () {
      reject(new Error('网络错误：无法连接到服务器，可能是CORS问题或服务器不可达'));
    };
    xhr.ontimeout = function () {
      reject(new Error('请求超时'));
    };

    // 设置超时时间
    xhr.timeout = options.timeout || 10000;
    xhr.send(options.data);
  });
}
function isEmptyObject(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      return false; // 对象不为空
    }
  }
  return true; // 对象为空
}
export { isEmptyObject, http, Dom, DomEl, CommonCaptcha, clearAllPreventDefault, down, move, up, initConfig, _showTips as showTips, _closeTips as closeTips, destroyEvent };